import { render, staticRenderFns } from "./CupsModal.vue?vue&type=template&id=1bc36a3c&"
import script from "./CupsModal.vue?vue&type=script&lang=js&"
export * from "./CupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports